import { useSilver } from "@/context/SilverContext";
import { AnimatedNumber } from "@/components/silver/common/AnimatedNumber";

const SAMPLE = ["RG40", "RG41", "SW18"];

export function PatchStrip() {
  const { areas, audience, addAreas } = useSilver();
  if (!areas.length) {
    return (
      <div className="flex flex-wrap items-center gap-3" data-testid="empty-patch-state">
        <p className="text-[17px] font-semibold text-white">Start with your patch.</p>
        <span className="text-[13px] text-white/45">Try</span>
        {SAMPLE.map((c) => (
          <button key={c} type="button" className="pill" onClick={() => addAreas([c])} data-testid={`sample-postcode-${c}`}>{c}</button>
        ))}
        <button type="button" className="pill" onClick={() => addAreas(["RG40", "RG41"])} data-testid="sample-postcode-pair">RG40 + RG41</button>
      </div>
    );
  }
  return (
    <p className="text-[15px] text-white/60" data-testid="patch-summary">
      <span className="font-semibold text-white">{areas.length} postcode district{areas.length > 1 ? "s" : ""}</span> ·{" "}
      <AnimatedNumber value={audience.silverTotal} duration={0.8} className="num font-semibold text-white" /> homeowner households in your patch
    </p>
  );
}
